import React from 'react';
import { FlexBox, Text } from '@eltoro-ui/components';

const SoldListingPromotion = () => {
  return (
    <FlexBox
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      UNSAFE_className="card_content"
    >
      <FlexBox alignItems="center" justifyContent="space-between" UNSAFE_style={{ width: '100%' }}>
        <FlexBox
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          UNSAFE_className="heading"
        >
          <Text on="white" weight="bold" UNSAFE_className="title">
            Sold Listing Promotion
          </Text>
          <Text on="white" UNSAFE_className="desc">
            Beewo alerts you when a listing of yours is sold, so that you can alert the neighbors
            that you closed a good deal.
          </Text>
        </FlexBox>
      </FlexBox>
      {/* <FlexBox justifyContent="center" alignItems="center" UNSAFE_className="library_card_content"> */}
      {/*  <Button size="l" disabled kind="primary" weight="bold"> */}
      {/*    Explore Your Sold Listings */}
      {/*  </Button> */}
      {/* </FlexBox> */}
    </FlexBox>
  );
};

export default SoldListingPromotion;
